import { Environment } from '@shared/tokens/environment';
import { environment as prodEnvironment } from './environment.prod';

export const environment: Environment = {
	...prodEnvironment,
	production: false,
};
